import type { Location } from '../types/crm';

/**
 * Real columns of the public.locations table (verified 30 Oct 2026):
 * id, customer_id, name, address, city, county, postcode, country,
 * contact_name, contact_email, contact_phone, notes, is_active, is_default, is_training_location.
 * The old CRM names (address_line_1/2/3, county_state, eircode_postcode, location_contact_*,
 * location_notes) do not exist; selecting them fails with 42703.
 */
export const LOCATION_DB_SELECT =
  'id, name, address, city, county, postcode, country, contact_name, contact_email, contact_phone, notes';

/** Map a locations row (real columns, with legacy-name fallbacks) to the app Location shape. */
export function mapLocationDbRow(loc: Record<string, any>): Location {
  return {
    id: String(loc.id),
    addressLine1: String(loc.address || loc.address_line_1 || loc.name || '').trim(),
    addressLine2: String(loc.address_line_2 || '').trim(),
    addressLine3: String(loc.address_line_3 || '').trim(),
    city: String(loc.city || ''),
    eircodePostcode: String(loc.postcode || loc.eircode_postcode || ''),
    countyState: String(loc.county || loc.county_state || ''),
    country: String(loc.country || ''),
    locationContactName: String(loc.contact_name || loc.location_contact_name || ''),
    locationContactEmail: (loc.contact_email ?? loc.location_contact_email ?? null) as string | null,
    locationContactPhone: String(loc.contact_phone || loc.location_contact_phone || ''),
    locationNotes: String(loc.notes || loc.location_notes || ''),
  };
}